import { render, staticRenderFns } from "./documentsReport.vue?vue&type=template&id=118ee586"
import script from "./documentsReport.vue?vue&type=script&lang=js"
export * from "./documentsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports